import './ifit-rating.component.scss'

import { Swiper, Pagination } from 'swiper'
Swiper.use(Pagination)
document.querySelectorAll('.ifit-rating__slider').forEach((root) => {
  const swiperElement = root.querySelector('.swiper-container')
  if (swiperElement) {
    new Swiper(swiperElement, {
      slidesPerView: 1,
      spaceBetween: 10,
      pagination: {
        el: swiperElement.querySelector('.swiper-pagination'),
        type: 'bullets',
        clickable: true
      },
      breakpoints: {
        spaceBetween: 40
      }
    })
  }
})
